import Swiper from 'swiper'
import {Thumbs} from "swiper/modules";


export class Slider {
  constructor() {
    this._sliderMain = document.querySelector('.c-vehicule-slider--main')
    this._sliderThumbs = document.querySelector('.c-vehicule-slider--thumbs')

    if (!this._sliderMain) return;

    this.init();
  }

  init() {
    let swiperThumbs = new Swiper(this._sliderThumbs, {
      spaceBetween: 28,
      slidesPerView: 2,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        450: {
          slidesPerView: 3,
        }
      }
    });

    let swiperMain = new Swiper(this._sliderMain, {
      spaceBetween: 10,
      modules: [Thumbs],
      thumbs: {
        swiper: swiperThumbs,
      },
    })
  }
}
